/**
 * Postgres TEXT and JSONB reject U+0000. JSONB also rejects unpaired
 * UTF-16 surrogates. PDF/DOCX extract and LLM copies often embed both.
 *
 * Iterate by code point so valid supplementary-plane characters (emoji)
 * stay intact — a range match on U+D800–U+DFFF would delete each half
 * of a well-formed surrogate pair.
 */
const POSTGRES_NUL = 0x0000;
const SURROGATE_START = 0xd800;
const SURROGATE_END = 0xdfff;

export function sanitizePostgresText(value: string): string {
  let sanitized = '';
  for (const character of value) {
    const codePoint = character.codePointAt(0);
    if (codePoint === undefined) continue;
    if (codePoint === POSTGRES_NUL) continue;
    if (codePoint >= SURROGATE_START && codePoint <= SURROGATE_END) continue;
    sanitized += character;
  }
  return sanitized;
}

export function sanitizeJsonStrings(value: unknown): unknown {
  if (typeof value === 'string') return sanitizePostgresText(value);
  if (Array.isArray(value)) return value.map(sanitizeJsonStrings);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, nested]) => [
        key,
        sanitizeJsonStrings(nested),
      ]),
    );
  }
  return value;
}
